import PropTypes from 'prop-types';

import applyFormTheme from './applyFormTheme';
import { formThemeShape } from './PropTypes';

const FormThemeConsumer = ({ children, overrides }, { formTheme }) =>
  children(applyFormTheme(formTheme, overrides));

FormThemeConsumer.propTypes = {
  children: PropTypes.func.isRequired,
  overrides: formThemeShape,
};

FormThemeConsumer.contextTypes = { formTheme: formThemeShape };

export default FormThemeConsumer;
